import React, { forwardRef } from "react";

import { AppTimePickerProps } from "./AppTimeSelect.d";
import SlotTimePicker from "react-datepicker";
// import { InputLabel, TextField } from "@mui/material";
import TextField from "@mui/material/TextField";
import { TimePicker } from "@mui/x-date-pickers";

export const AppTimePickerMaterial = forwardRef(AppTimePickerMaterialComponent);
export function AppTimePickerMaterialComponent(
  { className, ...props }: AppTimePickerProps,
  ref
) {
  return (
    <div className={"w-full " + className}>
      <TimePicker
        {...props}
        renderInput={(params) => <TextField {...params} fullWidth />}
        inputRef={ref}
      />
    </div>
  );
}

export const AppTimePickerStandard = forwardRef(AppTimePickerStandardComponent);
export function AppTimePickerStandardComponent(
  {
    className,
    onChange = () => {},
    enableTimesInRange = [],
    fontFamilyForLabel = "",
    fontFamilyForInput = "",
    ...props
  }: AppTimePickerProps,
  ref
) {
  const filterTime = (time) => {
    return enableTimesInRange.some((range) => {
      const startTime = range.start.getTime();
      const endTime = range.end.getTime();
      const currentTime = time.getTime();
      return currentTime >= startTime && currentTime <= endTime;
    });
  };
  return (
    <div className={"w-full" + className}>
      <div style={{ marginBottom: "7px" }}>
        <label
          className={
            fontFamilyForLabel != ""
              ? fontFamilyForLabel
              : "MBCorpoAScreen1Cond-Regular-Web"
          }
          style={{ color: "#FFFFFF" }}
        >
          {props.label}
        </label>
      </div>
      <SlotTimePicker
        {...props}
        onChange={(e) => {
          onChange(e);
        }}
        selected={props.value}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={30}
        dateFormat="HH:mm"
        timeFormat="HH:mm"
        filterTime={filterTime}
        customInput={
          <TextField
            inputRef={ref}
            InputProps={{
              readOnly: true,
              sx: {
                height: "63px",
                // width: isSmallScreen ? "356px" : "114px",
                fontFamily: "MBCorpoSTitle-Regular-Web-STitle-Regular",
              },
            }}
            InputLabelProps={{
              sx: {
                "&.MuiInputLabel-root": {
                  fontFamily:
                    fontFamilyForInput != ""
                      ? fontFamilyForInput
                      : "MBCorpoSTitle-Regular-Web-new",
                  marginTop: "5px",
                },
                "&.MuiInputLabel-shrink": {
                  marginTop: "13px",
                  color: "#00ADEF",
                  fontFamily: "MBCorpoSTitle-Regular-Web-new",
                  display: "none",
                },
              },
            }}
            label={props.label}
            required={props.required}
            // style={{ backgroundColor: "#FFFFFF" }}
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "8px",
            }}
            fullWidth
          />
        }
        timeCaption={props.label}
      />
    </div>
  );
}
